<template>
  <div class="comp-orders">
    <h1 class="headline">ORDERS</h1>

    <div class="toolbar">
      <div class="btns">
        <button type="button" class="btn btn-outline-black w180" @click="showModalAdd = true">+ New Order</button>
      </div>

      <div class="filters">
        <div class="input-search">
          <input type="text" name="s" class="form-control" placeholder="SEARCH ORDERS..." v-model="keyword"
                 @change="doPaging(1)">
        </div>
        <v-select v-model="ftSupplier" :options="allSuppliers" class="ft-supplier" :reduce="item => item.id"
                  label="name" :searchable="true" placeholder="ALL SUPPLIERS"></v-select>
        <v-select v-model="ftCreator" :options="allStaff" class="ft-creator" :reduce="item => item.id"
                  label="full_name" :searchable="true" placeholder="ALL CREATORS"></v-select>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
        <tr>
          <th width="120"><a href="javascript:;">ORDER NO</a></th>
          <th width="120"><a href="javascript:;">JOB NO</a></th>
          <th><a href="javascript:;">SUPPLIER</a></th>
          <th><a href="javascript:;">DETAILS</a></th>
          <th width="120"><a href="javascript:;">COST</a></th>
          <th width="100"><a href="javascript:;">STATUS</a></th>
          <th><a href="javascript:;">CREATED BY</a></th>
          <th width="40"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(order, index) in orders" :key="index">
          <td>
            <router-link :to="{name: 'order', params: {orderId: order.id}}" class="black">{{ order.order_number }}</router-link>
          </td>
          <td>
            <router-link v-if="order.job" :to="{ name: 'job', params: { jobId: order.job_id } }" class="black">
              {{ (order.client?order.client.code:'') + order.job_id }}
            </router-link>
          </td>
          <td>
            <router-link v-if="order.supplier" :to="{ name: 'supplier', params: { itemId: order.supplier_id } }" class="black">
              {{ order.supplier.full_name }}
            </router-link>
          </td>
          <td>{{ order.description }}</td>
          <td>{{ order.cost | moneyFormat }}</td>
          <td>{{ order.status | statusToUCWords }}</td>
          <td>{{ order.creator?order.creator.full_name:'' }}</td>
          <td class="text-right actions">
            <a href="javascript:;" class="icon-copy" v-tooltip="'Duplicate order'"
               @click="confDuplicate(index)"></a>&nbsp;
            <a href="javascript:;" class="icon-trash" v-tooltip="'Delete order'"
               @click="confDelete(index)"></a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-if="hasFilters && orders.length == 0" class="alert alert-warning">
      No orders found
    </div>
    <div class="d-flex justify-content-between">
      <div class="actions"></div>
      <pagination :total-pages="totalPages" :current-page="currentPage" @goto-page="doPaging"></pagination>
    </div>

    <modal-add-order v-model="showModalAdd" @added="onOrderAdded"></modal-add-order>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import ServiceOrder from '@/services/order'
  import ModalAddOrder from './ModalAddOrder'
  import ModalDuplicate from './ModalDuplicate';

  export default {
    components: {
      ModalAddOrder
    },
    data() {
      return {
        showModalAdd: false,
        keyword: '',
        activeIndex: -1,
        ftCreator: '',
        ftSupplier: '',
        totalItems: 0,
        currentPage: 1,
        totalPages: 0,
        orders: []
      }
    },
    watch: {
      ftCreator: function () {
        this.doPaging(1);
      },
      ftSupplier: function () {
        this.doPaging(1);
      }
    },
    computed: {
      ...mapState({
        allSuppliers: state => state.option.suppliers,
        orderStatuses: state => state.option.orderStatuses,
        allStaff: state => state.option.users,
      }),
      statusOpts() {
        let self = this, opts = [];
        for (var i in self.orderStatuses) {
          opts.push({label: window.stringToUCWords(self.orderStatuses[i]), value: self.orderStatuses[i]});
        }
        return opts;
      },
      hasFilters() {
        let self = this;
        return self.ftCreator != '' || self.ftSupplier != '' || self.keyword != '';
      },
      totalOrderValue() {
        let self = this, total = 0;
        for (var i in self.orders) {
          total += self.orders[i].total_value;
        }
        return total;
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.showModalAdd = false;
        this.getOrders();
      },
      confDuplicate(index) {
        let self = this;
        self.$modal.show(ModalDuplicate, {
          index: index,
          order: self.orders[index]
        }, {
          clickToClose: false,
          width: 592
        });
      },
      onOrderAdded(order) {
        let self = this;
        self.$router.push({
          name: 'order',
          params: {
            orderId: order.id
          }
        });
      },
      confDelete(index) {
        let self = this, item = self.orders[index];
        self.$dialog
          .confirm('Are you sure you want to delete order #<strong>' + item.id + '</strong>?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            ServiceOrder.delete(item.id, () => {
              dialog.close();
              self.orders.splice(index, 1);
              self.$notify({
                type: 'success',
                text: 'Order <strong>' + item.name + '</strong> has been deleted'
              });
            });
          })
          .catch(() => {
          })
        ;
      },
      doPaging(page) {
        let self = this;
        self.currentPage = page;
        self.getOrders();
      },
      getOrders() {
        let self = this,
          params = {
            page: self.currentPage,
          };

        if (self.ftCreator !== '') {
          params.created_by = self.ftCreator;
        }
        if (self.ftSupplier !== '') {
          params.client_id = self.ftSupplier;
        }
        if (self.keyword !== '') {
          params.kw = self.keyword;
        }

        self.state = 'loading';
        ServiceOrder.getOrders(params, resp => {
          self.state = 'loaded';
          self.orders = resp.data;
          self.totalPages = resp.last_page;
          self.totalItems = resp.total;
        });
      }
    }
  }
</script>
